<div class="mat-dialog-container">
  <mat-dialog-content>
    
    <div class="row mb-3">
      <div class="col-10 d-flex justify-content-center text-black">
        {{data}}
      </div>
      <div class="col-2 d-flex justify-content-end">
        <span class="cursor" [mat-dialog-close]="true">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="18"
            height="18"
            viewBox="0 0 18 18"
            fill="none"
          >
            <path
              d="M1.53379 17.8661L0.133789 16.4661L7.60046 8.99948L0.133789 1.53281L1.53379 0.132812L9.00046 7.59948L16.4671 0.132812L17.8671 1.53281L10.4005 8.99948L17.8671 16.4661L16.4671 17.8661L9.00046 10.3995L1.53379 17.8661Z"
              fill="black"
            />
          </svg>
        </span>
      </div>
      
    </div>
  </mat-dialog-content>
</div>
